import * as React from "react";
import { withStyles, CircularProgress } from "@material-ui/core";
import styles from './Loader.styles';
/**
 * Компонент отображающий индикатор загрузки
 * @param props
 * @constructor
 */

function Loader(props) {
  var classes = props.classes,
      size = props.size,
      wrapper = props.wrapper;
  var style = {};

  if (size) {
    style.width = size;
    style.height = size;
  }

  var loader = React.createElement("div", {
    className: classes.progressContent
  }, React.createElement(CircularProgress, {
    className: classes.progress,
    style: style,
    color: "inherit"
  }));
  return wrapper ? React.createElement("div", {
    className: classes.wrapper
  }, loader) : loader;
}

export default withStyles(styles, {
  name: 'Loader'
})(Loader);